import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { merchantTheme } from 'theme'

const t = buildTranslate('recovery_ai.restricted_customers.badge')

// Maps a restriction status to its badge label key. The active list returns
// `active`; everything else falls back to the generic "restricted" label so an
// unexpected status never renders a raw key. Extend here as new statuses ship.
const STATUS_LABEL_KEY: Record<string, string> = {
  active: 'restricted',
}

type Props = {
  status: string
}

// A dedicated "blocked" pill — NOT the shared StatusBadge, which is keyed to the
// ActivityStatus union (it has no `restricted` member and would fall through to
// grey "pending"). Cayenne (red) carries the blocked/negative semantics used
// across RecoveryAI. Decorative styling only; the label text conveys the meaning.
const RestrictedBadge = ({ status }: Props) => {
  const [css] = useStyletron()
  const labelKey = STATUS_LABEL_KEY[status] ?? 'restricted'

  return (
    <span
      className={css({
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 600,
        backgroundColor: merchantTheme.colors.cayenne10,
        color: merchantTheme.colors.cayenne50,
      })}
    >
      {t(labelKey)}
    </span>
  )
}

export default RestrictedBadge
